<template>
  <v-row>
    <v-col cols="12 py-0 pt-2 px-8">
      <h3>Danh sách Đơn vị (PnL) áp dụng</h3>
      <div><span class="text-hint">Tìm kiếm thêm vào</span></div>
    </v-col>
    <v-col cols="12" class="px-8 py-0 pt-2">
      <v-simple-table class="table-layout table-custom table-sku">
        <thead>
          <tr>
            <th class="col-name">Đơn vị kinh doanh</th>
            <th class="col-action text-center">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <v-autocomplete
                class="text-field text-field-no-message"
                :clearable="true"
                :items="campaignBu"
                item-value="code"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn đơn vị"
                attach
                outlined
                dense
                v-model="buCode"
                :disabled="isDisableActive"
                @change="onSelectSku"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </td>
            <td class="text-center">
              <v-tooltip bottom class="mr-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addSku" :disabled="isDisableActive">
                    mdi-plus-box
                  </v-icon>
                </template>
                <span>Thêm</span> 
              </v-tooltip>
            </td>
          </tr>
          <tr v-for="(item, index) in pnlCodes" :key="index">
            <td>
              {{ campaignBuObj[item.code] }}
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeSku(item, index)" :disabled="isDisableActive">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Xóa</span>
              </v-tooltip>
            </td>
          </tr>
          <tr style="height: 200px;"></tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import {
  campaignTypeOfApplicationOrder,
  campaignTypeOfApplicationSKU,
  campaignTypeOfApplicationCategory,
} from '../../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    pnlCodes: {
      type: Array,
      default: () => [],
    },
    campaignBu: {
      type: Array,
      default: () => [],
    },
    isDisablePending: {
      type: Boolean,
      default: () => false,
    },
    isDisableActive: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
  },
  data() {
    return {
      campaignTypeOfApplicationOrder,
      campaignTypeOfApplicationSKU,
      campaignTypeOfApplicationCategory,
      buCode: null,
      campaignBuObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.campaignBu.forEach((item) => {
      this.campaignBuObj[item.code] = item.name;
    })
  },
  beforeDestroy() {
  },
  methods: {
    onSelectSku() {},
    addSku() {
      const bu = this.campaignBu.find((item) => item.code === this.buCode);
      if(!bu) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Đơn vị không tồn tại',
        });
      }

      const isExistBu = this.pnlCodes.find((item) => item.code === this.buCode);
      if(isExistBu) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Đơn vị đã được thêm',
        });
      }

      if(bu) {
        this.pnlCodes.push({
          code: this.buCode,
          // name: bu.name,
          // skuType: bu.itemType,
        });
      }
      this.buCode = null;
      
    },
    removeSku(item, index) {
      this.pnlCodes.splice(index, 1);
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 300px;
}

.table-custom {
  th {
    background: #E7E8FF;
    border-left: 1px solid #fff;
  }
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.text-hint {
  font-style: italic;
  font-size: 12px;
  color: #696969;
}
</style>
